import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';

function Dashboard({ user, apiUrl, token }) {
  const navigate = useNavigate();
  const [stats, setStats] = useState({
    bookings: 0,
    invoices: 0,
    services: 0,
    totalSpent: 0
  });
  const [recentBookings, setRecentBookings] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const headers = { Authorization: `Bearer ${token}` };

        // Fetch bookings
        const bookingsRes = await axios.get(`${apiUrl}/bookings`, { headers });
        setRecentBookings(bookingsRes.data.slice(0, 5));
        setStats(prev => ({
          ...prev,
          bookings: bookingsRes.data.length
        }));

        // Fetch invoices
        const invoicesRes = await axios.get(`${apiUrl}/invoices`, { headers });
        const totalSpent = invoicesRes.data.reduce((sum, inv) => sum + parseFloat(inv.amount || 0), 0);
        setStats(prev => ({
          ...prev,
          invoices: invoicesRes.data.length,
          totalSpent: totalSpent.toFixed(2)
        }));

        // Fetch services
        const servicesRes = await axios.get(`${apiUrl}/services`, { headers });
        setStats(prev => ({
          ...prev,
          services: servicesRes.data.length
        }));
      } catch (err) {
        console.error('Error fetching dashboard data:', err);
      }
    };

    fetchData();
  }, [apiUrl, token]);

  return (
    <div className="dashboard">
      <h1>Welcome, {user?.name}! ✨</h1>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">📅</div>
          <div className="stat-content">
            <div className="stat-value">{stats.bookings}</div>
            <div className="stat-label">Total Bookings</div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">💰</div>
          <div className="stat-content">
            <div className="stat-value">${stats.totalSpent}</div>
            <div className="stat-label">Total Spent</div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">💎</div>
          <div className="stat-content">
            <div className="stat-value">{stats.invoices}</div>
            <div className="stat-label">Invoices</div>
          </div>
        </div>

        <div className="stat-card">
          <div className="stat-icon">⭐</div>
          <div className="stat-content">
            <div className="stat-value">{stats.services}</div>
            <div className="stat-label">Available Services</div>
          </div>
        </div>
      </div>

      <div className="dashboard-section">
        <h2>Recent Bookings</h2>
        {recentBookings.length > 0 ? (
          <table className="table">
            <thead>
              <tr>
                <th>Service</th>
                <th>Practitioner</th>
                <th>Date</th>
                <th>Status</th>
                <th>Price</th>
              </tr>
            </thead>
            <tbody>
              {recentBookings.map(booking => (
                <tr
                  key={booking.id}
                  onClick={() => navigate(`/bookings/${booking.id}`)}
                  style={{ cursor: 'pointer' }}
                >
                  <td>{booking.service_name}</td>
                  <td>{booking.practitioner_name}</td>
                  <td>{new Date(booking.booking_date).toLocaleDateString()}</td>
                  <td>
                    <span className={`badge badge-${booking.status === 'confirmed' ? 'success' : 'warning'}`}>
                      {booking.status}
                    </span>
                  </td>
                  <td>${booking.price}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="empty-state">No bookings yet. Start by browsing our services!</p>
        )}
      </div>
    </div>
  );
}

export default Dashboard;
